<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>工讀生管理</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <a href="/"><i class="fa fa-home"></i></a>
          </li>
          <li><span>助學金管理系統</span></li>
          <li><span>工讀生管理</span></li>
          <li><span>排班年月設定</span></li>
        </ol>
      </div>
    </header>
    <div class="row">
      <div class="col-md-12">
        <section class="panel">
          <ul class="nav nav-tabs" role="tablist">
            <li>
              <router-link :to="'/workstudy'">工讀生清單</router-link>
            </li>
            <li v-if="isAdmin('stipendMage')">
              <router-link :to="'/workstudy/treaty'">設定隱私權宣告、管理辦法</router-link>
            </li>
            <li class="active" v-if="isAdmin('stipendMage')">
              <router-link :to="'/workstudy/scheduleSetting'">排班年月設定</router-link>
            </li>
          </ul>
          <header class="panel-heading">
            <h2 class="panel-title">排班年月設定</h2>
          </header>
          <div class="panel-body container-fluid">
            <div class="row form-group">
              <div class="col-md-12 form-group">
                <label class="col-md-3 control-label">額外開放班表年月：</label>
                <div class="col-md-9">
                  <input
                    type="text"
                    class="form-control"
                    v-model="form.openYearMonth"
                    placeholder="格式 yyyyMM，多筆以逗號分隔，例：202606,202607"
                    :style="{maxWidth: '400px'}"
                  />
                  <p class="help-block">輸入後，該年月即使已超過原本 25 號規則仍可新增或刪除排班；未列出的年月仍依原本規則判斷。</p>
                </div>
              </div>
              <div class="col-md-12 form-group">
                <label class="col-md-3 control-label">提前鎖定班表年月：</label>
                <div class="col-md-9">
                  <input
                    type="text"
                    class="form-control"
                    v-model="form.lockYearMonth"
                    placeholder="格式 yyyyMM，多筆以逗號分隔，例：202606,202607"
                    :style="{maxWidth: '400px'}"
                  />
                  <p class="help-block">輸入後，該年月會優先鎖定；若同時也出現在額外開放年月，仍以提前鎖定為準。</p>
                </div>
              </div>
            </div>
            <div class="row form-group">
              <div class="col-md-12 text-center">
                <button @click="handleCancel" class="btn btn-default" style="margin-right:8px;">取消</button>
                <button @click="handleSave" class="btn btn-primary">儲存</button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </section>
</template>

<script>
/* global bootbox */
export default {
  data() {
    return {
      form: {
        openYearMonth: "",
        lockYearMonth: ""
      }
    };
  },
  created() {
    this.$axios.get("/api/systemsetting?key=WorkstudyScheduleSetting").then(resp => {
      if (resp.data.status === "success" && resp.data.data && resp.data.data.value) {
        try {
          const parsed = JSON.parse(resp.data.data.value);
          if (Object.prototype.hasOwnProperty.call(parsed, "openYearMonth")) {
            this.form.openYearMonth = this.normalizeYearMonths(parsed.openYearMonth || "");
          }
          if (Object.prototype.hasOwnProperty.call(parsed, "lockYearMonth")) {
            this.form.lockYearMonth = this.normalizeYearMonths(parsed.lockYearMonth || "");
          }
        } catch (e) {
          // 解析失敗時保留預設值
        }
      }
    });
  },
  methods: {
    normalizeYearMonths(value) {
      return [...new Set((value || "").split(",").map(item => item.trim()).filter(Boolean))].join(",");
    },
    isValidYearMonths(value) {
      if (!value) {
        return true;
      }
      return value.split(",").every(item => /^\d{6}$/.test(item));
    },
    handleCancel() {
      this.$router.push({ path: "/workstudy" });
    },
    handleSave() {
      const openYearMonth = this.normalizeYearMonths(this.form.openYearMonth);
      const lockYearMonth = this.normalizeYearMonths(this.form.lockYearMonth);
      if (!this.isValidYearMonths(openYearMonth)) {
        bootbox.alert("「額外開放班表年月」請輸入 yyyyMM 格式，多筆請用逗號分隔");
        return;
      }
      if (!this.isValidYearMonths(lockYearMonth)) {
        bootbox.alert("「提前鎖定班表年月」請輸入 yyyyMM 格式，多筆請用逗號分隔");
        return;
      }

      this.form.openYearMonth = openYearMonth;
      this.form.lockYearMonth = lockYearMonth;
      const body = {
        key: "WorkstudyScheduleSetting",
        value: JSON.stringify({ openYearMonth, lockYearMonth })
      };
      this.$axios.post("/api/systemsetting", body).then(resp => {
        if (resp.data.status === "success") {
          bootbox.alert("儲存成功");
        } else {
          bootbox.alert(resp.data.msg || "儲存失敗");
        }
      });
    }
  }
};
</script>

<style scoped>
</style>
